import style from 'styled-components';

export const StyledCard = style.div`
    box-shadow: 2px 2px 10px rgb(0 0 0 / 10%);
    border-radius: 10px;
    padding: ${({ padding }) => padding || '2rem 2.5rem'};
    background-color: ${({ background }) => background || 'white'};
`;
